import React, { useEffect, useState } from "react";
import { Icon } from "../../../icons/icons";
import Step from "../../Reservations/Step";
import GuestInformation from "./GuestInformation";
import { useTranslation } from "../../../context/TranslationContext";

const ReservationGuestInformation = ({
  setOpen,
  passengerInformationData,
  loginData,
  rez,
  list,
}) => {
  const {
    customer,
    reservationGuestInformationTitle,
    reservationGuestInformationTitleName1,
    reservationGuestInformationTitleName2,
    reservationGuestInformationSubTitle,
    close,
  } = useTranslation();
  const [activeTabs, setActiveTabs] = useState([]);
  const [formData, setFormData] = useState([]);
  const [page, setPage] = useState(1);
  const [validTabs, setValidTabs] = useState([]);
  const [step, setStep] = useState(0);

  const [tabList, setTabList] = useState([]);
  useEffect(() => {
    let CustomerTitle = [];
    for (
      let index = 0;
      index < passengerInformationData.reservation.totalPassenger;
      index++
    ) {
      CustomerTitle.push(
        <Step
          status={
            activeTabs.includes(index) ? 2 : validTabs.includes(index) ? 1 : 0
          }
          key={index}
        >
          {customer} {index + 1}
        </Step>
      );
    }
    setTabList(CustomerTitle);
  }, [activeTabs]);

  useEffect(() => {
    setActiveTabs([page - 1]);
  }, [page]);

  return (
    <>
      {step != "2" && (
        <div className="flex sm:flex-nowrap flex-wrap items-start justify-between last:mr-auto first:ml:">
          <>
            <div className="flex flex-col sm:order-1 order-2 flex-auto">
              <span
                className="xmd:text-[23px] text-[17px]  text-dark font-semibold leading-8 mb-[10px]"
                dangerouslySetInnerHTML={{
                  __html: reservationGuestInformationTitle
                    .replace(
                      "{reservationId}",
                      passengerInformationData.reservation.id
                    )
                    .replace(
                      "{name}",
                      step == 0
                        ? reservationGuestInformationTitleName1
                        : reservationGuestInformationTitleName2
                    ),
                }}
              ></span>
              {step == 0 && (
                <div className="flex items-center mb-8">
                  <div className="text-[#C11046]">
                    <Icon name={"problemreport"}></Icon>
                  </div>
                  <span
                    className="text-13 font-semibold  leading-4 ml-[6px] text-dark"
                    dangerouslySetInnerHTML={{
                      __html: reservationGuestInformationSubTitle.replace(
                        "{count}",
                        passengerInformationData.reservation.totalPassenger
                      ),
                    }}
                  ></span>
                </div>
              )}
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="bg-transparent shadow-none flex items-center sm:order-2 order-1 sm:ml-0 ml-auto"
            >
              <Icon name={"close"}></Icon>
              <span className="text-dark text-13 font-semibold leading-4 ml-3">
                {close}
              </span>
            </button>
          </>
        </div>
      )}

      {step == 0 && (
        <div className="flex items-center min-h-0 whitespace-nowrap overflow-x-auto w-full mb-[50px]">
          {tabList}
        </div>
      )}
      <div>
        <GuestInformation
          activeTabs={activeTabs}
          page={page}
          setPage={setPage}
          formData={formData}
          setFormData={setFormData}
          validTabs={validTabs}
          setValidTabs={setValidTabs}
          step={step}
          setStep={setStep}
          passengerInformationData={passengerInformationData}
          passenger={passengerInformationData.reservation.totalPassenger}
          loginData={loginData}
          id={rez.hashed}
          setOpen={setOpen}
          list={list}
        />
      </div>
    </>
  );
};

export default ReservationGuestInformation;
